module.exports = __webpack_public_path__ + "assets/img/DK.f642a200.jpg";